import {Categoria} from "../models/Categoria";

export const URL_API = 'https://api.toqweb.com.br:2004/SuperZapp/toqweb'

export const AMOUNT_OF_REGISTER_ON_PAGINATION = 50

export const categoriaPadrao: Categoria = {id: 0, name: 'TODAS CATEGORIAS'}

export const PREFIX_MONEY = 'R$ '
